import { useMemo } from "react";
import { useSelector } from "react-redux";
import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import { shellSelectors } from "store/selectors";

/*
Receives an array or roles to check against the users roles array and
returns a hash with the roles checked as keys and the booleans as values
*/

export const useHasRoles = searchedRoles => {
	const { roles } = useSelector(shellSelectors.user);

	return useMemo(() => {
		const rolesHash = {};

		if (isNonEmptyArray(searchedRoles) && isNonEmptyArray(roles)) {
			searchedRoles.forEach(searchedRole => {
				rolesHash[searchedRole] = roles.some(role => role.groupName === searchedRole);
			});
		}

		return rolesHash;
	}, [ roles, searchedRoles ]);
};

export default useHasRoles;
